import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-checkbox',
  template: `<div class='abx-checkbox'><i [class]='getCheckboxClass()'></i></div>`,
  styles: []
})
export class CheckboxComponent {
  @Input() checkboxType: string;
  @Input() value: any;
  @Input() onValue: any;

  constructor() { }

  getCheckboxClass() {

    var onStyle = this.checkboxType === "box" ? "sw-check sw-check-square-o" : "sw-check sw-dot-circle-o";
    var offStyle = this.checkboxType === "box" ? "sw-check sw-square-o" : "sw-check sw-circle-o";

    return (this.value === this.onValue) ? onStyle : offStyle;

  }
}
